module.exports = __webpack_public_path__ + "img/orange_061.477c20b0.png";